import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Ticker from "../components/Ticker";
import Services from "../components/Services";
import About from "../components/About";
import WhyUs from "../components/WhyUs";
import ServiceAreas from "../components/ServiceAreas";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import FloatingDock from "../components/FloatingDock";
import Footer from "../components/Footer";

export default function LandingPage() {
    return (
        <main data-testid="landing-page" className="bg-white">
            <Navbar />
            <Hero />
            <Ticker />
            <Services />
            <About />
            <WhyUs />
            <ServiceAreas />
            <FAQ />
            <Contact />
            <Footer />
            <FloatingDock />
        </main>
    );
}
